export const useConfig = () => {
  return window.clutter;
};
